import { GET_INTERVIEW_RESPONSE } from "graphql/queries";
import { useQueryData } from "hooks";

/**
 * useInterviewResponse
 *
 * @param {String} uuid
 */
export default function useInterviewResponse({ uuid, enabled }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_INTERVIEW_RESPONSE,
    keyName: "interviewResponse",
    variables: { uuid, enabled },
    skip: !uuid,
  });

  return { data: data?.interviewResponse, loading, error };
}
